"use client";

import React from "react";
import { Container, FilterTitle } from "./FilterContainer.styles";
import { Text } from "@lmn/design-system";
import Accordion from "@/components/UI/Accordion/Accordion";

interface Props {
  title: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

const FilterContainer: React.FC<Props> = ({ title, icon, children }) => {
  return (
    <Container>
      <Accordion
        trigger={
          <FilterTitle>
            {icon && icon}
            <Text variant="Title5" margin={0} weight="semibold">
              {title}
            </Text>
          </FilterTitle>
        }
        triggerPosition="top"
        withChevronRight={true}
        isOpenByDefault={true}
      >
        {children}
      </Accordion>
    </Container>
  );
};

export default FilterContainer;
